import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from "primeng/components/common/selectitem";
import { Message } from 'primeng/components/common/api';
import { CreateUserModel, User } from '../../../models/outModels/User';
import { UserService } from '../../../services/user/user.service';
import { StorageService } from "../../../services/system/storage.service";
import { BusinessService as BusinessCategoryService } from "../../../services/business/business-category.service";
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { AuthenticationService } from "../../../services/authentication/authentication.service";

@Component({
	selector: 'app-users-create',
	templateUrl: './users-create.component.html',
	styleUrls: ['./users-create.component.css']
})
export class UsersCreateComponent implements OnInit {
	model: CreateUserModel;
	loading = false;
	error: Message[];
	groups: SelectItem[];
	categories: SelectItem[];
	clients;
	selectedClient;
	uploading = false;
	selectedProgramme;
	programmes: SelectItem[];
	messages: Message[];
	
	constructor(
		private router: Router,
		private auth: AuthenticationService,
		private userService: UserService,
		public storageService: StorageService,
		public businessService: BusinessCategoryService,
		private confirmationService: ConfirmationService) {
		this.getGroups();
		this.getCategories();
	}

	ngOnInit() {
		this.model = new CreateUserModel();
		this.model.Groups.push(4);

	}

	goBack(): void {
		this.router.navigate(['/users']);
	}

	save(): void {
		this.model.DateOfBirth = this.auth.convertToUtc(this.model.DateOfBirth);

		this.loading = true;
		this.userService.create(this.model).then(
			user => {
				this.confirmationService.confirm({
					header: 'Success',
					icon: 'fa fa-user',
					message: 'User created',
					acceptLabel: "Create Business Profile",
					accept: () => {
						this.router.navigate(['/users/business/profile', user.Id]);
					},
					rejectLabel: "Go Back",
					reject: () => {
						this.router.navigate(['/users']);
					}
				});
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getGroups() {
		this.loading = true;
		this.userService.getGroupsList().then(
			x => {
				this.groups = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getCategories() {
		this.loading = true;
		this.businessService.getDropdownList().then(
			x => {
				this.categories = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		
		this.model.ProfilePictureId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.ProfilePictureId = null;
		this.loading = false;
	}

	initClientDropDown(event): void {
	
		this.businessService.getDropdownClients(event).then(
			result => {
				if (result.length == 0) {
					this.emptyMessage = "Client not found, press enter to create";
				}
				this.clients = result;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	setClient(): void {
		this.model.Client = this.selectedClient.value;
		this.emptyMessage = null;
	}

	emptyMessage = "Client not found, press enter to create";
	addClient(event) {
		if (event.key === 'Enter') {
			this.loading = true;
			this.businessService.getOrAddClient(event.target.value).then(
				result => {
					this.clients = [];
					this.clients.push(result);
					this.selectedClient = result;
					this.setClient();
					
					this.loading = false;
				},
				error => {
					this.loading = true;
				});
		}
	}

		setProgramme(): void {
		this.model.ProgrammeId = this.selectedProgramme.value;
		this.emptyMessage = null;
	}


	initProgrammeDropDown(event): void {
		this.userService.getProgrammesDropDown(event).then(
			result => {
				this.programmes = result;
			},
			error => {
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/users/users-create/users-create.component.ts